import type { RouteRecordRaw } from 'vue-router'
import { APP_CONFIG } from '../../../crypto-otc/src/project-config'
import { PageRoutes } from '../../../platform-config/src/router/PageRoutes'

export const routes88: RouteRecordRaw[] = [
  {
    path: PageRoutes.Home,
    component: () => import('../views/HomeView/index.tsx'),
    meta: {
      title: '首页',
    },
  },
  ...(APP_CONFIG.isCompliant
    ? [
        {
          path: PageRoutes.LegalCompliance,
          component: () => import('../views/LegalComplianceView/LegalCompliance'),
          meta: {
            title: '执法请求',
          },
        },
      ]
    : []),
]
